import React, { useEffect, useRef, useState } from "react";
import SideMenu from "../SideMenu/SideMenu";
// useAuth imported above
import { useTranslation } from "react-i18next";
import { TimezoneDisplay } from "../TimezoneDisplay/TimezoneDisplay";
import "./TopMenu.css";
import { useAuth } from "../../util/Auth";

export default function TopMenu() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  
  const leftMenuRef = useRef<HTMLDivElement | null>(null);
  const rightMenuRef = useRef<HTMLDivElement | null>(null);
  const { user } = useAuth();
  const { t, i18n } = useTranslation();

  function handleToggleLeftMenu() {
    setIsMenuOpen((prev) => !prev);
  }

  const userName =
    `${user?.first_name ?? ""} ${user?.last_name ?? ""}`.trim() || "Usuario";

  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      const target = event.target as Node | null;
      if (!target) {
        return;
      }

      const clickedLeft = leftMenuRef.current?.contains(target) ?? false;
      if (!clickedLeft) {
        setIsMenuOpen(false);
      }
    }

    if (isMenuOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isMenuOpen]);

  return (
    <header className="top-menu">
      <div className="top-menu__left" ref={leftMenuRef}>
        <button
          type="button"
          className="top-menu__button"
          onClick={handleToggleLeftMenu}
        >
          {t("menu")}
        </button>
        {isMenuOpen && (
          <div className="top-menu__dropdown">
            <SideMenu onItemClick={() => setIsMenuOpen(false)} />
          </div>
        )}
      </div>
      <span className="top-menu__center">{t("systemTitle")}</span>
      <div className="top-menu__right" ref={rightMenuRef}>
        <TimezoneDisplay />
        <span className="top-menu__language">{i18n.language.toUpperCase()}</span>
        <span className="top-menu__user-name">{userName}</span>
      </div>
    </header>
  );
}
